import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { artifactTreePath, phase0TabPath } from './workspace/projectPhases';

interface ProjectLegacyRedirectProps {
  to: 'overview' | 'artifacts' | 'report' | 'handoff' | 'delta' | 'inventory' | 'intake' | 'scan';
}

const TARGET: Record<Exclude<ProjectLegacyRedirectProps['to'], 'artifacts'>, string> = {
  overview: 'repo',
  report: 'baseline',
  handoff: 'baseline',
  delta: 'repo',
  inventory: 'repo',
  intake: 'upload',
  scan: 'repo',
};

const ProjectLegacyRedirect: React.FC<ProjectLegacyRedirectProps> = ({ to }) => {
  const { projectId = '' } = useParams();
  if (to === 'artifacts') {
    return <Navigate to={artifactTreePath(projectId)} replace />;
  }
  return <Navigate to={phase0TabPath(projectId, TARGET[to])} replace />;
};

export default ProjectLegacyRedirect;
